module.exports = __webpack_public_path__ + "static/media/fpm4.03f4d5a1.png";